import { useLocation } from "react-router-dom";
import GroupForm from "../../organisms/GroupForm";
import { useGroupDetail } from "../../../api/admin/group/hooks";
import { useEffect } from "react";

/**
 * 그룹 상세 화면 - 일반 사용자
 */
const GroupDetail = () => {
    const groupIdx = useLocation().pathname.split("/").pop()
    const { data, isLoading } = useGroupDetail(groupIdx)
    const groupDetail = data?.data || []

    useEffect(() => {
        if (data) {
            console.log("@GroupDetail", groupDetail);
        }
    }, [data])

    if (!groupDetail) return null
    return (
        <GroupForm
            initData={{
                title: groupDetail.name,
                description: groupDetail.description,
                groupUsers: groupDetail.user || []
            }}
            editable={false}
        />
    )
}

export default GroupDetail